<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M7 9.81098V20.5C7 22.1569 8.34315 23.5 10 23.5H22C23.6569 23.5 25 22.1569 25 20.5V13.939C25 12.2822 23.6569 10.939 22 10.939H8.46951C7.65792 10.939 7 10.2811 7 9.46951V9.46951C7 8.65792 7.65792 8 8.46951 8H18.2037C19.7869 8 21.0703 9.28343 21.0703 10.8666V10.8666"
        stroke="black" stroke-width="2" />
    <path
        d="M24.625 15.3369H21.1688C20.1522 15.3369 19.3281 16.161 19.3281 17.1776V17.1776C19.3281 18.1942 20.1522 19.0183 21.1688 19.0183H24.625"
        stroke="black" stroke-width="2" />
</svg>

